<template>
  <div>
    <div class="content-wrapper">
      <!-- Header Section -->
      <div class="row">
        <div class="col-md-12 grid-margin">
          <div class="row">
            <div class="col-12 mb-0 mb-xl-0">
              <h4 class="font-weight-bold">
                Application Logs
                <ToolTip
                  content="Troubleshoot application issues. Logs from you application are displayed in this table. You can filter by log level, action type or menu"
                />
              </h4>
            </div>
          </div>
        </div>
      </div>

      <!-- Search Form Section -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <form>
                <div class="row">
                  <label class="col-sm-1 col-form-label"></label>
                  <div class="col-sm-3">Menus</div>
                  <div class="col-sm-3">Action Type</div>
                  <div class="col-sm-3">Log Level</div>
                  <div class="col-sm-2"></div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-1 col-form-label"></label>
                  <!-- Menu Filter -->
                  <div class="col-sm-3">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <input
                            type="checkbox"
                            v-model="searchFilter.filterByMenu"
                          />
                        </div>
                      </div>
                      <select
                        class="form-control form-control-sm"
                        v-model="searchFilter.menuId"
                        :disabled="searchFilter.filterByMenu == false"
                      >
                        <option value="">..Select Menu..</option>
                        <option
                          v-for="(option, index) in menusList"
                          v-bind:value="option.uniqueId"
                          :key="index"
                        >
                          {{ option.displayText }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!-- Action Type Filter -->
                  <div class="col-sm-3">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <input
                            type="checkbox"
                            v-model="searchFilter.filterByPlugin"
                          />
                        </div>
                      </div>
                      <select
                        class="form-control form-control-sm"
                        :disabled="searchFilter.filterByPlugin == false"
                        v-model="searchFilter.plugin"
                      >
                        <option value="">..Select one..</option>
                        <option value="javascript">Javascript</option>
                        <option value="restapi">Rest Api Calls</option>
                        <option value="dbaccess">Database Calls</option>
                        <option value="sendsms">Sms Sending</option>
                        <option value="paymentprompt">Payment Prompt</option>
                      </select>
                    </div>
                  </div>
                  <!-- Log Level Filter -->
                  <div class="col-sm-3">
                    <div class="input-group mb-3">
                      <div class="input-group-prepend">
                        <div class="input-group-text">
                          <input
                            type="checkbox"
                            v-model="searchFilter.filterByLevel"
                          />
                        </div>
                      </div>
                      <select
                        class="form-control form-control-sm"
                        :disabled="searchFilter.filterByLevel == false"
                        v-model="searchFilter.level"
                      >
                        <option value="">..Select one..</option>
                        <option value="system">System</option>
                        <option value="debug">Debug</option>
                        <option value="info">Info</option>
                        <option value="error">Error</option>
                      </select>
                    </div>
                  </div>
                  <!-- Filter Button -->
                  <div class="col-sm-2">
                    <button
                      type="button"
                      class="btn btn-success text-white"
                      @click="searchLogs()"
                    >
                      Filter
                      <span
                        class="circle-loader ml-2"
                        style="display: none"
                        id="loader"
                      ></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Log View Section -->
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <!-- Clear Logs Button -->
              <div class="d-flex justify-content-end mb-3">
                <button 
                  class="btn btn-danger btn-sm text-white" 
                  @click="clearLogs"
                >
                  <i class="fa fa-trash"></i> Clear Logs
                </button>
              </div>
              <!-- View Tabs -->
              <ul class="nav nav-pills nav-pills-success" id="pills-tab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="pills-terminal-tab"
                    data-bs-toggle="pill"
                    href="#terminal"
                    role="tab"
                    aria-controls="terminal"
                    aria-selected="true"
                  >
                    Log View
                  </a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-table-tab"
                    data-bs-toggle="pill"
                    href="#table"
                    role="tab"
                    aria-controls="table"
                    aria-selected="false"
                  >
                    Table View
                  </a>
                </li>
              </ul>

              <!-- Tab Content -->
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="terminal" role="tabpanel" aria-labelledby="pills-terminal-tab">
                  <ActionLogTerminalView :appId="appId" :logs="filteredLogs" />
                </div>
                <div class="tab-pane fade" id="table" role="tabpanel" aria-labelledby="pills-table-tab">
                  <ActionLogTableView :appId="appId" :logs="filteredLogs" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolTip from "@/components/tooltipComponent.vue";
import ActionLogTerminalView from "@/components/actionLogTerminalView.vue";
import ActionLogTableView from "@/components/actionLogTableView.vue";
import baseUrl from "@/shared/baseUrl";
import { useToast } from "vue-toastification";
import api from "@/shared/menuApi";

export default {
  name: 'ActionLogView',
  components: {
    ToolTip,
    ActionLogTerminalView,
    ActionLogTableView
  },
  data() {
    return {
      appId: this.$route.params.id,
      searchFilter: {
        appId: this.$route.params.id,
        filterByMenu: false,
        filterByLevel: false,
        filterByPlugin: false,
        level: "",
        menuId: "",
        plugin: "",
      },
      filteredLogs: [],
      menusList: [],
    };
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  async mounted() {
    console.log('ActionLogView mounted, initializing...');
    await this.getMenusLite();
    // Initial log fetch after a short delay to ensure component is ready
    setTimeout(() => this.searchLogs(), 2000);
  },
  methods: {
    /**
     * Fetches the list of menus for the current application
     */
    async getMenusLite() {
      try {
        console.log('Fetching menus for app:', this.appId);
        this.menusList = await api.getAllMenusLite(this.appId);
        console.log('Menus fetched successfully:', this.menusList.length);
      } catch (error) {
        console.error('Error fetching menus:', error);
        this.toast.error('Failed to fetch menus');
      }
    },

    /**
     * Searches logs based on the current filter settings
     */
    searchLogs() {
      try {
        const payload = Object.assign(this.searchFilter);
        console.log('Searching logs with filter:', payload);
        $("#loader").show();
        
        baseUrl.post("/actionlogs/searchLogs", payload).then((res) => {
          $("#loader").hide();
          if (res.data.status == "00") {
            console.log('Logs fetched successfully:', res.data.data.length);
            this.filteredLogs = res.data.data;
          } else {
            console.warn('No logs found or error in response:', res.data);
            this.filteredLogs = [];
          }
        });
      } catch (error) {
        $("#loader").hide();
        console.error('Error searching logs:', error);
        this.toast.error('Failed to search logs');
      }
    },

    /**
     * Clears all logs for the current application
     */
    clearLogs() {
      try {
        console.log('Clearing logs for app:', this.appId);
        baseUrl.post("/actionlogs/clearLogs", { appId: this.appId }).then((res) => {
          if (res.data.status == "00") {
            console.log('Logs cleared successfully');
            this.toast.success("Logs cleared successfully");
            this.filteredLogs = [];
          } else {
            console.warn('Failed to clear logs:', res.data);
            this.toast.error("Failed to clear logs");
          }
        });
      } catch (error) {
        console.error('Error clearing logs:', error);
        this.toast.error("Failed to clear logs");
      }
    }
  }
};
</script>

<style lang="css" scoped>
/* Navigation Pills Styling */
.nav-pills {
  margin-bottom: 1rem;
}

.nav-pills .nav-link {
  color: #495057;
  cursor: pointer;
  border-radius: 0.25rem;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;
}

.nav-pills .nav-link.active {
  background-color: #28a745;
  color: #fff;
}

/* Tab Content Styling */
.tab-content {
  padding: 1rem 0;
}

/* Form Control Styling */
select,
select:focus {
  color: rgb(15, 8, 8);
}

select:disabled {
  color: rgb(171, 169, 169);
}
</style>
